<template>
    <div>
        <v-app class="p-4">
            <!--        <ads-selector></ads-selector>-->
            <div class="p-0 mt-5 pt-5" style="border: none!important;">

                <categoryselector :editCategory="current" :edit_def="true" @category-schema="getSchema"
                                  @category-fields="getFields"
                                  ref="category"
                                  :multiAdsCat="false">
                </categoryselector>
                <div class="col-md-11 mx-auto">

                    <div class="col-md-8 mx-auto px-0">
                        <city-selector  :defaultEdit="false" :editCity="infos.location" ref="city"
                                       :force="true"></city-selector>
                    </div>
                    <div class="col-md-8 pt-0 mx-auto px-0" v-if="Object.keys(infos).length > 0">
                        <pic-selector :is_edit="true" :editImg="infos.images"></pic-selector>
                    </div>
                </div>

                <div class="px-5 mx-1 pt-0">
                    <input-maker ref="inputs" :editField="infos" :param="schema.advertise" :ui_schema="this.ui_schema"
                                 :fields="this.fields"></input-maker>
                </div>

                <setting-ads :edit-mode="infos.contact" :auto-pay="infos.auto_pay" class="pr-5"></setting-ads>
                <div class="col-md-8 mr-auto">
                    <v-btn type="submit" class="submit-btn float-left" elevation="8" @click="authenticate">
                        <span class="fa fa-save pr-1" style="font-size: 1.3rem"></span>
                        بروزرسانی آگهی
                    </v-btn>
                </div>
            </div>
        </v-app>
    </div>
</template>

<script>
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import Categoryselector from "@/view/pages/ads/categorySelector";
import CitySelector from "@/view/pages/ads/citySelector";
import NumberSelector from "@/view/pages/ads/numberSelector";
import PicSelector from "@/view/pages/uploadCenter/picSelector";
import SettingAds from "@/view/pages/ads/settingAds";
import inputMaker from "@/view/pages/ads/inputMaker";
import Swal from "sweetalert2";
import {Bus} from "@/main";

export default {
    name: "editDef",
    components: {SettingAds, PicSelector, NumberSelector, CitySelector, Categoryselector, TitleRibbon, inputMaker},
    props: {
        ui_schema: {
            type: Array,
            default() {
                return []
            }
        },
        modal: {
            default: false,
        },
        fields: {
            type: Array,
            default() {
                return [];
            }
        },
        edit: {
            type: Boolean,
            default: false,
        },
        editToken: {
            type: String,
            default: () => ""
        },
    },
    data() {
        return {
            current: '',
            schema: {
                advertise: {
                    category: "",
                    location: {
                        city: "",
                        neighborhood: ""
                    },
                    images: [],
                },
                available_at: '',
                expire_at: '',
                auto_pay: '',
            },
            EditToken: this.editToken,
            infos: []
        }
    },
    methods: {
        getSchema: function (value) {
            this.ui_schema = value;
        },
        getFields: function (val) {
            this.fields = val;
        },
        getadsData() {
            $.ajax({
                url: `${url}/default/${this.editToken}`,
                type: 'GET',
                fn: this.getadsData,
                headers: {
                    ACCEPT: 'application/json',
                    Authorization: Token
                },
                success: (data) => {
                    this.current = data.data.data.advertise.category;
                    this.infos = data.data.data.advertise;
                    this.schema.advertise = data.data.data.advertise;
                }
            });
        },
        authenticate() {
            this.$modal.showLoading();
            $.ajax({
                url: `${url}/divar/check/title`,
                type: "POST",
                fn: this.authenticate,
                headers: {
                    ACCEPT: "application/json",
                    Authorization: Token,
                    "Content-type": 'application/json'
                },
                data: JSON.stringify({
                    "title": this.schema.advertise['title'],
                    "city": String(this.schema.advertise.location.city),
                    "category": this.schema.advertise.category
                }),
                msg: false,
                error: (data) => {
                    if (data.status === 422) {
                        this.$modal.error('خطا', 'لطفا اطلاعات فرم را کامل نمایید.')
                    } else {
                        this.$modal.error('خطا', 'عنوان مورد نظر قابل قبول نمی باشد.');
                    }
                },
                success: (data) => {
                    this.updateAds();
                }
            });

        },
        updateAds() {
            const data = this.schema;
            if (!this.$refs.inputs.validate() || !this.$refs.city.validate())
                return;
            if (data.available_at === "" || !data.available_at) {
                delete data.available_at;
            }
            if (data.expire_at === "" || !data.expire_at) {
                delete data.expire_at;
            }
            $.ajax({
                url: `${url}/default/${this.editToken}`,
                method: 'PUT',
                fn: this.updateAds,
                msg: true,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: Token,
                    ACCEPT: 'application/json'
                },
                data: JSON.stringify({data: data}),
                success: () => {
                    this.modal()
                }
            })
        }
    },
    watch: {
        infos() {
            setTimeout(() => {
                Bus.$emit('getBreadCrumb', 10);
            }, 1000)
        },
        editToken() {
            this.current = '';
            this.infos = [];
            this.schema.advertise = {};
            this.getadsData()
        }
    },
    mounted() {
        this.current = '';
        this.infos = [];
        this.schema.advertise = {};
        this.getadsData();
        Bus.$on('category-current', (value) => {
            this.schema.advertise.category = value;
        });
        Bus.$on('cityInfo', (value) => {
            this.schema.advertise.location.city = value.city;
            if (value.neighborhood === '')
                delete this.schema.advertise.location.neighborhood
            else
                this.schema.advertise.location.neighborhood = value.neighborhood

                });
        Bus.$on('contact', (value) => {
            this.schema.advertise.contact.chat_enabled = value.chat_enabled;
            this.schema.advertise.contact.hide_phone = value.hide_phone;
            this.schema.auto_pay = value.autoPay;
        });
        Bus.$emit('editCategory', this.current);
        Bus.$on('selected_numbers', (value) => {
            this.schema.advertise.contact.phone = value
        });
        Bus.$on('selectedImage', (value) => {
            this.schema.advertise.images = value;
        });
        Bus.$on('parameters', (value) => {
            this.schema.advertise = value;
        });
    }

}
</script>

<style scoped>

</style>